import Vue from 'vue';

import { store } from '../vuex/store';
import { routes } from './routes';
import VueRouter from 'vue-router';
Vue.use( VueRouter );

const router = new VueRouter({

  mode: 'history',
  routes
});

router.beforeEach( ( to, from, next ) => {

  if ( to.query.pwaSlug && window.matchMedia( '(display-mode: standalone)' ).matches ) {

    console.log( 'display-mode is standalone' );
    console.log( 'before redirect slug: ', to.query.pwaSlug );
    next({

      name   : 'home',
      params : { slug: to.query.pwaSlug }
    });
  } else {

    if ( [ 'home' ].includes( to.name ) && [ 'order-menu' ].includes( from.name ) ) {

      store.dispatch( 'orderMenu/clearState' );
    }

    const url = to.path.split( '/' );
    const slug = url[ 2 ];
    console.log( 'incoming slug: ', slug );
    console.log( 'existing slug: ', store.getters[ 'merchant/merchantSlug' ] );

    console.log( 'route from: ', from );
    console.log( 'route to: ', to );

    if( store.getters[ 'merchant/merchantSlug' ] != null && store.getters[ 'merchant/merchantSlug' ] != slug ){
      // these two conditions mean: a merchantSlug is already saved off, and it is different than the one attempting to be navigated to at this moment

      // this will clear all state, essentially restarting the app
      
      if (slug !== 'merchants') {
        console.log( 'new slug detected! clearing database.. slug it is different merchants' );
        store.dispatch( 'clearIndexDb' );
      }
    }

    if ( to.query.phone ) {
      console.log( 'got here to auth via phone', to.query.phone );
      
      let base64Url = to.query.phone.split( '.' )[ 1 ];
      let base64    = base64Url.replace( '-', '+' ).replace( '_', '/' );
      const data    = JSON.parse( window.atob( base64 ) );

      console.log( 'data from url ', data );

      store.dispatch( 'auth/phoneUser', data.phoneNumber )
      .then( () => {

          console.log( 'before redirect slug: ', slug );
          next({

            name   : 'not-found'
          });
        });

    } else if ( to.query.jwt ) {
        console.log( 'got here to auth JWT phone', to.query.jwt );

        store.dispatch( 'auth/authUsingJwt', to.query.jwt )
        .then( () => {

          console.log( 'before redirect slug: ', slug );
          next({

            name   : 'home',
            params : { slug: slug }
          });
        });
    } else { // console.log( 'no jwt in query..' );

      switch ( to.name ) {

        case 'not-found':
          //console.log( 'routing to merchants...' );
          next();
          break;
        case 'signin':

          console.log( 'routing to signin...' );
          store.dispatch( 'nav/hideHeader' );
          if( store.getters[ 'auth/isAuth' ] && store.getters[ 'merchant/merchantSlug' ] ){

            console.log( 'signin redirecting to home..' );
            next({

              name   : 'home',
              params : { slug : store.getters[ 'merchant/merchantSlug' ] }
            });
          } else next();
          break;
        case 'home':

          console.log( 'the redirect to home is here' );
          //console.log( 'isAuth: ', store.getters[ 'auth/isAuth' ] );
          //console.log( 'merchantSlug: ', store.getters[ 'merchant/merchantSlug' ] );
          if( store.getters[ 'auth/isAuth' ] && store.getters[ 'merchant/merchantSlug' ] && store.getters[ 'merchant/currentLocation' ] == null ){

            console.log( 'the redirect to home got to first block' );
            store.dispatch( 'nav/hideHeader' );
            next({

              name: 'merchant-location',
              params : { slug : store.getters[ 'merchant/merchantSlug' ] }
            });
           
          } else if ( !store.getters[ 'auth/isAuth' ] || !store.getters[ 'merchant/merchantSlug' ] ) {
            console.log( 'the redirect to home got to second block' );
            var merchants = '';
            merchants = store.getters[ 'orderMenu/allMerchants' ];
            
            console.log('merchants ==>>', merchants.length);
            console.log('currentLocation ==>>', localStorage.getItem('currentLocation'));
            console.log('merchantLocations ==>>', localStorage.getItem('merchantLocations'));
            
            if ( merchants.length <= 0 || 
                (localStorage.getItem('currentLocation') == null &&
                localStorage.getItem('merchantLocations') == null) ) {
                store.dispatch( 'orderMenu/showLocationsBySlug', slug);
            }
            
            store.dispatch( 'nav/showHeader' );
            next();
           
          } else {

            console.log( 'the redirect to home got to third block' );
            store.dispatch( 'nav/showHeader' );
            next();
          }
          break;
        case 'order-menu'    :
        case 'order-history' :
        case 'view-order'    :
        case 'in-app-msg'    :
        case 'view-msg'      :
        case 'transactions'  :
        case 'manage-cards'  :
        case 'order-tab'     :
          console.log( 'route order-tab' );
          store.dispatch( 'nav/hideHeader' );
          next();
          break;
        case 'merchant-location':
          console.log( 'route merchant-location' );
          store.dispatch( 'nav/hideHeader' );
          next();
        break;
        case 'merchant-delivery':
          console.log( 'the redirect to merchant-delivery here' );
          store.dispatch( 'nav/hideHeader' );
          next();
          break;
        case 'delivery-address':
            console.log( 'the redirect to delivery-address here' );
            store.dispatch( 'nav/hideHeader' );
            next();
            break;
        case 'delivery-pickup-spot':
            console.log( 'the redirect to delivery-pickup-spot here' );
            store.dispatch( 'nav/hideHeader' );
            next();
            break;
        case 'delivery-building':
            console.log( 'the redirect to delivery-building here' );
            store.dispatch( 'nav/hideHeader' );
            next();
            break;
        case 'full-delivery':
            console.log( 'the redirect to full-delivery here' );
            store.dispatch( 'nav/hideHeader' );
            next();
            break;
        case 'profile':

          if( store.getters[ 'auth/isAuth' ] && store.getters[ 'merchant/merchantSlug' ] && store.getters[ 'merchant/currentLocation' ] == null ){

            store.dispatch( 'nav/hideHeader' );
            store.dispatch( 'nav/saveIntendedRoute', to.name );
            next({

              name: 'merchant-location',
              params : { slug : store.getters[ 'merchant/merchantSlug' ] }
            });
          } else if( !store.getters[ 'auth/isAuth' ] || !store.getters[ 'merchant/merchantSlug' ] ){

            next({

              name: 'signin',
              params : { slug : slug }
            });
          } else {

            store.dispatch( 'nav/hideHeader' );
            next();
          }
          break;
        default:

          if( !store.getters[ 'merchant/merchantSlug' ] ){

            next({

              name : 'not-found'
            });

          } else if( !store.getters[ 'auth/isAuth' ] ){
            next({

              name: 'signin',
              params : { slug : store.getters[ 'merchant/merchantSlug' ] }
            });
          } else {

            store.dispatch( 'nav/hideHeader' );
            next();
          }
          break;
      }
    }
  }
});

router.afterEach( ( to, from ) => {

  store.dispatch( 'updateNavigation', { to, from } );
})
export default router;